import { items } from './Items'
import { entities } from './Entities'

export const Interfaces = {
  hotbar: {
    width: 128,
    height: 156,
    bg: '/assets/interface-hotbar.png',
    inventories: { local: 'equipment' },
    targetCells: [],
    localCells: [
      { x: 24, y: 132, idx: 0, select: true }, // hot 1
      { x: 44, y: 132, idx: 1, select: true }, // hot 2
      { x: 64, y: 132, idx: 2, select: true }, // hot 3
      { x: 84, y: 132, idx: 3, select: true }, // hot 4
    ],
    extras: [
      { x: 107, y: 134, type: 'goEquipment', w: 18, h: 18 },
      { x: 3, y: 134, type: 'goChat', w: 18, h: 18 },
      { x: 23, y: 125, type: 'resonance' },
    ],
  },
  chat: {
    width: 128,
    height: 156,
    bg: '/assets/interface-chat.png',
    inventories: { local: 'equipment' },
    targetCells: [],
    localCells: [
      { x: 24, y: 132, idx: 0, select: true }, // hot 1
      { x: 44, y: 132, idx: 1, select: true }, // hot 2
      { x: 64, y: 132, idx: 2, select: true }, // hot 3
      { x: 84, y: 132, idx: 3, select: true }, // hot 4
    ],
    extras: [
      { x: 107, y: 134, type: 'goEquipment', w: 18, h: 18 },
      { x: 3, y: 134, type: 'goHotbar', w: 18, h: 18 },
      { x: 3, y: 60, type: 'chat', w: 122, h: 68 },
    ],
  },
  equipment: {
    width: 128,
    height: 156,
    bg: '/assets/interface-equipment.png',
    inventories: { local: 'equipment' },
    targetCells: [],
    localCells: [
      { x: 24, y: 132, idx: 0 }, // hot 1
      { x: 44, y: 132, idx: 1 }, // hot 2
      { x: 64, y: 132, idx: 2 }, // hot 3
      { x: 84, y: 132, idx: 3 }, // hot 4
      { x: 4, y: 86, idx: 4 },
      { x: 24, y: 86, idx: 5 },
      { x: 44, y: 86, idx: 6 },
      { x: 64, y: 86, idx: 7 },
      { x: 84, y: 86, idx: 8 },
      { x: 104, y: 86, idx: 9 },
      { x: 4, y: 108, idx: 10 },
      { x: 24, y: 108, idx: 11 },
      { x: 44, y: 108, idx: 12 },
      { x: 64, y: 108, idx: 13 },
      { x: 84, y: 108, idx: 14 },
      { x: 104, y: 108, idx: 15 },
      { x: 4, y: 17, idx: 16 }, // head
      { x: 4, y: 39, idx: 17 }, // chest
      { x: 4, y: 61, idx: 18 }, // legs
      { x: 104, y: 17, idx: 19 }, // rItem
      { x: 104, y: 39, idx: 20 }, // back
      { x: 104, y: 61, idx: 21 }, // boots
    ],
    extras: [
      { x: 7, y: 7, type: 'text', text: 'Gear', size: 7 },
      { x: 112, y: 4, type: 'goHotbar', w: 11, h: 11 },
      { x: 107, y: 134, type: 'goHotbar', w: 18, h: 18 },
      { x: 3, y: 134, type: 'goChat', w: 18, h: 18 },
    ],
  },
  station: {
    width: 128,
    height: 156,
    bg: '/assets/interface-station.png',
    inventories: { local: 'equipment' },
    targetCells: [],
    localCells: [
      { x: 24, y: 132, idx: 0 }, // hot 1
      { x: 44, y: 132, idx: 1 }, // hot 2
      { x: 64, y: 132, idx: 2 }, // hot 3
      { x: 84, y: 132, idx: 3 }, // hot 4
      { x: 4, y: 86, idx: 4 },
      { x: 24, y: 86, idx: 5 },
      { x: 44, y: 86, idx: 6 },
      { x: 64, y: 86, idx: 7 },
      { x: 84, y: 86, idx: 8 },
      { x: 104, y: 86, idx: 9 },
      { x: 4, y: 108, idx: 10 },
      { x: 24, y: 108, idx: 11 },
      { x: 44, y: 108, idx: 12 },
      { x: 64, y: 108, idx: 13 },
      { x: 84, y: 108, idx: 14 },
      { x: 104, y: 108, idx: 15 },
    ],
    extras: [
      { x: 6, y: 6, type: 'text', text: '{name}', size: 7 },
      { x: 112, y: 4, type: 'goHotbar', w: 11, h: 11 },
      { x: 3, y: 134, type: 'goChat', w: 18, h: 18 },
      { x: 6, y: 17, type: 'craftArea', w: 116, h: 65 },
    ],
  },
  container: {
    width: 128,
    height: 156,
    bg: '/assets/interface-container.png',
    inventories: { local: 'equipment', target: 'container' },
    targetCells: [
      { x: 4, y: 17, idx: 0 },
      { x: 24, y: 17, idx: 1 },
      { x: 44, y: 17, idx: 2 },
      { x: 64, y: 17, idx: 3 },
      { x: 84, y: 17, idx: 4 },
      { x: 104, y: 17, idx: 5 },
      { x: 4, y: 39, idx: 6 },
      { x: 24, y: 39, idx: 7 },
      { x: 44, y: 39, idx: 8 },
      { x: 64, y: 39, idx: 9 },
      { x: 84, y: 39, idx: 10 },
      { x: 104, y: 39, idx: 11 },
      { x: 4, y: 61, idx: 12 },
      { x: 24, y: 61, idx: 13 },
      { x: 44, y: 61, idx: 14 },
      { x: 64, y: 61, idx: 15 },
      { x: 84, y: 61, idx: 16 },
      { x: 104, y: 61, idx: 17 },
    ],
    localCells: [
      { x: 24, y: 132, idx: 0 }, // hot 1
      { x: 44, y: 132, idx: 1 }, // hot 2
      { x: 64, y: 132, idx: 2 }, // hot 3
      { x: 84, y: 132, idx: 3 }, // hot 4
      { x: 4, y: 86, idx: 4 },
      { x: 24, y: 86, idx: 5 },
      { x: 44, y: 86, idx: 6 },
      { x: 64, y: 86, idx: 7 },
      { x: 84, y: 86, idx: 8 },
      { x: 104, y: 86, idx: 9 },
      { x: 4, y: 108, idx: 10 },
      { x: 24, y: 108, idx: 11 },
      { x: 44, y: 108, idx: 12 },
      { x: 64, y: 108, idx: 13 },
      { x: 84, y: 108, idx: 14 },
      { x: 104, y: 108, idx: 15 },
    ],
    extras: [
      { x: 6, y: 6, type: 'text', text: '{name}', size: 7 },
      { x: 112, y: 4, type: 'goHotbar', w: 11, h: 11 },
      { x: 99, y: 4, type: 'takeAll', w: 11, h: 11 },
      { x: 3, y: 134, type: 'goChat', w: 18, h: 18 },
    ],
  },
}

const preloaded = new Map()

export function preloadInterfaces() {
  for (const ui of Object.values(Interfaces)) {
    preload(ui.bg)
  }
  preload('/assets/interface-highlight.png')
}

export function preloadAssets(loader) {
  for (const item of Object.values(items)) {
    // icons are loaded via CSS, so use browser-level preload
    if (item.icon) preload(item.icon)
    // equip layers and projectile sprites go through ImageLoader
    if (item.equip?.layers) {
      for (const layer of Object.values(item.equip.layers)) {
        loader.load(layer.url)
      }
    }
    if (item.use?.projectiles) {
      for (const proj of item.use.projectiles) {
        if (proj.flightSprite) loader.load(proj.flightSprite.url)
        if (proj.impactSprite) loader.load(proj.impactSprite.url)
        if (proj.shadowSprite) loader.load(proj.shadowSprite.url)
      }
    }
  }
  // base avatar layers are the same for every character
  loader.load('/assets/body.layer.png')
  loader.load('/assets/l-hand.layer.png')
  loader.load('/assets/r-hand.layer.png')
  // world entity sprites so the atlas can blit them the moment a chunk arrives
  for (const entity of Object.values(entities)) {
    if (entity.icon) loader.load(entity.icon)
  }
}

function preload(url) {
  if (preloaded.has(url)) return
  preloaded.set(url, null)
  if (typeof document !== 'undefined') {
    const link = document.createElement('link')
    link.rel = 'preload'
    link.as = 'image'
    link.href = url
    document.head.appendChild(link)
  }
}
